import { Injectable } from '@angular/core';

import { Medida } from "./medida.model";
import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";

@Injectable()
export class MedidaApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Medida, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Medida, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"medida"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/shared/medida-api.service.ts
 **/